import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ReactElement } from "react";
import { ExpertModeTheme } from "../../theme/expert-mode";

const Root = styled.div(css``)

const LabelRow = styled.div<{ expertTheme: ExpertModeTheme }>(
    props => css`
        display: flex;
        flex-direction: row;
        font-style: normal;
        font-size: 18px;
        line-height: 30px;
        border-bottom: 1px solid ${props.expertTheme.colors.subtle}; 
        font-family: 'inter-regular';
        margin-bottom: 30px;
    `)

const Label = styled.div<{ expertTheme: ExpertModeTheme, isSelected: boolean; }>(
    css`
        cursor: pointer;
        margin-right: 36px;
    `,
    props => props.isSelected ?
        css`
            color: ${props.expertTheme.colors.text};
            font-weight: 600;
        ` :
        css`
            color: ${props.expertTheme.colors.textLight};
            font-weight: 100;
        `)

const TabContent = styled.div(props => css`

`)

type Props<Id = unknown> = {
    expertTheme: ExpertModeTheme,
    tabs: Array<{
        id: Id,
        label: string,
        content: ReactElement
    }>,
    selectedTabId: Id,
    onSelect: (id: Id) => void
}

const Tabs = <Id extends string>({ tabs, expertTheme, selectedTabId, onSelect }: Props<Id>): ReactElement => {
    return (
        <Root>
            <LabelRow {...{ expertTheme }}>
                {tabs.map(tab =>
                    <Label
                        key={tab.id}
                        {...{ expertTheme }}
                        isSelected={tab.id === selectedTabId}
                        onClick={() => onSelect(tab.id)}>
                        {tab.label}
                    </Label>
                )}
            </LabelRow>
            <TabContent>
                {tabs.find(({ id }) => id === selectedTabId)?.content}
            </TabContent>
        </Root>
    )
}

export default Tabs